import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import LoginNew from './components/LoginNew';
import { isAuthenticated, validateToken, logout, getUser } from './services/auth';
import { Casca } from './components/casca/Casca';
import { CooperadoShell } from './components/cooperado/CooperadoShell';
import './components/casca/casca.css';

const App = () => {
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    // Verificar se há token válido ao carregar
    const checkAuth = async () => {
      if (isAuthenticated()) {
        const isValid = await validateToken();
        setAuthenticated(isValid);
      } else {
        setAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  const handleLoginSuccess = () => {
    // Depois do login, a tela de entrada (o Monitor, para quem pode vê-lo),
    // e não o endereço em que a pessoa estava: "/" é resolvido pela casca
    // (spec 0087, DD-07).
    window.history.replaceState(null, '', '/');
    setAuthenticated(true);
  };

  const handleLogout = async () => {
    await logout();
    setAuthenticated(false);
  };

  if (authenticated === null) {
    return <div className="casca-verificando" role="status">Verificando a sessão…</div>;
  }

  if (!authenticated) {
    return <LoginNew onLoginSuccess={handleLoginSuccess} />;
  }

  // ─── Painel do cooperado (spec 0034) ───────────────────────────────
  // Casca própria, fora do menu do painel. Gate aditivo: não remove nada de
  // quem já usava o painel com este cargo (DD-06 da 0034).
  if (getUser()?.domCargo === 'Motorista') {
    return <CooperadoShell onLogout={handleLogout} />;
  }

  // ─── O painel: um menu só, o do topo, sobre URLs (spec 0087) ───────
  return (
    <BrowserRouter>
      <Casca onLogout={handleLogout} />
    </BrowserRouter>
  );
};

export default App;
